import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, ConfigProvider, message } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import AntdProForm, { ModalForm } from '@ant-design/pro-form';
import { PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { APPLICATION_TYPES } from '../../constants/form';
import { SelectRole, SelectFaculty, SelectDepartment } from '../input';
import { ASSIGN_APPOINTED_APPROVER } from '../../gql/approvalRoutes';

const AssignApproverModal = ({
  applicationType,
  sequence,
  refetchQueries,
  buttonText,
  prefixIcon,
}) => {
  const [form] = AntdProForm.useForm();
  const { id } = useParams();
  const [assign] = useMutation(ASSIGN_APPOINTED_APPROVER, {
    refetchQueries,
    onCompleted: () => message.success('Approver Assigned'),
  });

  return (
    <ConfigProvider locale={enUS}>
      <ModalForm
        form={form}
        title="Assign Approver"
        trigger={
          <Button type="primary" style={{ marginLeft: '16px' }}>
            {prefixIcon ?? <PlusOutlined />}
            {buttonText}
          </Button>
        }
        modalProps={{
          onCancel: () => console.log('run'),
        }}
        onFinish={async ({ role, faculty, department }) => {
          await assign({
            variables: {
              input: {
                id,
                applicationType,
                sequence,
                appointedApprover: {
                  role,
                  faculty,
                  department,
                },
              },
            },
          });
          return true;
        }}
      >
        <SelectRole />
        <SelectFaculty rules={[]} />
        <SelectDepartment form={form} rules={[]} />
      </ModalForm>
    </ConfigProvider>
  );
};

AssignApproverModal.defaultProps = {
  buttonText: 'Assign',
};

AssignApproverModal.propTypes = {
  applicationType: PropTypes.oneOf(APPLICATION_TYPES).isRequired,
  sequence: PropTypes.number.isRequired,
  buttonText: PropTypes.string.isRequired,
  prefixIcon: PropTypes.node,
};

export default AssignApproverModal;
